const selectMatched = (match, label) => {
  const foundIndex = match ? label.toLowerCase().indexOf(match == null ? void 0 : match.toLowerCase()) : void 0;
  let start = label, selected = "", end = "";
  return foundIndex != null && foundIndex !== -1 && match && (start = label.slice(0, foundIndex), selected = label.slice(foundIndex, foundIndex + (match.length ?? 0)), end = label.slice(foundIndex + match.length)), { start, selected, end };
};
export {
  selectMatched
};
//# sourceMappingURL=selectMatched.js.map
